import { render, staticRenderFns } from "./PlacementsEndComponentReviewDevelopment.vue?vue&type=template&id=6874dbac&"
import script from "./PlacementsEndComponentReviewDevelopment.vue?vue&type=script&lang=js&"
export * from "./PlacementsEndComponentReviewDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports